import type { ReactNode } from 'react';
import type { Tone } from '../types';

interface TagProps {
  children: ReactNode;
  tone?: Tone;
}

export function Tag({ children, tone = 'gray' }: TagProps) {
  return <span className={`tag ${tone}`}>{children}</span>;
}
